import '../styles/sites11-15/main.scss';
import "./cookie";
import {unsubscribeLogic} from "./unsubscribe";
import {paymentLogic} from "./paymentPagesLogic";
import {scrollLogic} from "./scrollLogic";
import {loginPageLogic} from "./login";
import {contactFormLogic} from "./contactForm";
import "./elements/faq";
import "./elements/slick";
import "./elements/header";
import {useCounters} from "./counters";
import {pricingSwitchersLogic} from "./elements/pricingSwitchersLogic";
import {reviewsSwitcherLogic} from "./reviewsSwitcherLogic";

document.addEventListener("DOMContentLoaded", () => {

  useCounters(".counters-container");
  pricingSwitchersLogic();
  scrollLogic();
  unsubscribeLogic();
  paymentLogic();
  loginPageLogic();
  contactFormLogic();
  reviewsSwitcherLogic()

  console.log('Common script is loaded');
});
